module.exports = __webpack_public_path__ + "img/close-finance-logo.913d93b2.svg";